
import dayjs from 'dayjs';
import Api from '@/utils/api';
import _ from 'lodash';
import Header from '../Header/Header.vue';
import BuyerAddress from './BuyerAddress.vue';
import Confirm from 'vux/src/components/confirm/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Selector from 'vux/src/components/selector/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
data() {
return {
showBack: false,
addressInfo: "",
couponList: [],
availableCoupons: [],
couponId: '',
products: [],
productList: [],
shippingMethodsList: [],
availableShippingMethodsList: [],
shippingMethod: {},
shippingMethodId: '',
shippingMethodName: '',
totalQuantity: 0,
countingQuantity: 0,
countingWeight: 0,
shippingQuantity: 0,
productsPrice: 0,
productsWeight: 0,
fixedFreight: false,
freight: 0,
discount: 0
}
},
computed: {
totalPrice () {
return this.productsPrice + this.freight - this.discount
}
},
components: {
BuyerAddress,
Confirm,
'm-header': Header,
Popup,
Radio,
Group,
Cell,
CellBox,
XImg,
Actionsheet,
Selector,
XDialog
},
created () {
this.getCouponsList()
this.initOrderProducts()
this.calProductNumbers()
Api.shippingMethodsList({limit: 0})
.then( res => {
this.shippingMethodsList = res.data
if (this.addressInfo) {
this.updateAvailableShippingMethodsList()
}
})
},
directives: {
TransferDom
},
methods: {
back() {
this.showBack = true;
},
onBackConfirm() {
if(this.fromFullPath){
this.$router.replace(this.fromFullPath);
}else{
this.$router.replace('/home');
}
},
getCouponsList() {
Api.getCouponsList({
available: '1'
}).then(res => {
this.couponList = res.data
this.calAvailableCoupons()
})
},
initOrderProducts() {
if(this.$route.query.selectedCart){ // 购物车过来
this.data = JSON.parse(this.$route.query.selectedCart)
_.forEach(this.data, (cart) => {
this.products.push({
product: cart.product._id,
quantity: cart.quantity
})
cart.product.quantity = cart.quantity
this.productList.push(cart.product)
})
} else if(this.$route.query.products){ // 产品过来
this.data = JSON.parse(this.$route.query.products)
_.forEach(this.data, (product) => {
this.products.push({
product: product._id,
quantity: 1
})
product.quantity = 1
this.productList.push(product)
})
} else if(this.$route.query.coupon){ // 优惠券过来
this.data = JSON.parse(this.$route.query.coupon)
_.forEach(this.data, (product) => {
this.products.push({
product: product._id,
quantity: product.quantity
})
if(product.isUseCoupon){
this.couponId = product.couponId
}
this.productList.push(product)
})
} else {
this.$router.replace('/home')
}
},
calProductNumbers () {
this.productsPrice = 0
this.totalQuantity = 0
this.productsWeight = 0
this.discount = 0
this.fixedFreight = false
this.freight = 0
_.forEach(this.productList, (product) => {
this.productsPrice += product.price * product.quantity
this.totalQuantity += product.quantity
if(product.weight){
this.productsWeight += product.weight * product.quantity
}
if (!product.freeShipping) {
this.countingQuantity += product.quantity
if(product.weight){
this.countingWeight += product.weight * product.quantity
}
}







})
},
calAvailableCoupons() {
const coupons = []
let bestCouponId = null
let maxCouponDiscount = 0
this.couponList.forEach((c) => {

if (dayjs(c.expirationDate).isAfter(dayjs())) {

const validProducts = []
let validQuantify = 0
let validTotalPrice = 0
let maxProductPrice = 0
let valid = false
let discount = 0
this.productList.forEach(p => {
if (c.products.indexOf(p._id) >= 0) {
validProducts.push(p)
maxProductPrice = Math.max(maxProductPrice, p.price)
validQuantify += p.quantity
validTotalPrice += p.price * p.quantity
}
})
if (validProducts.length > 0) {
if (c.type == 'free') {
discount = maxProductPrice
valid = true
} else if (c.type == 'cash-off' && validTotalPrice >= c.cashOffLimit) {
discount = c.cashOffValue
valid = true
} else if (c.type == 'rate-off' && validQuantify >= c.rateOffLimit) {
discount = Math.ceil(validTotalPrice * (10 - c.rateOffValue) / 10)
valid = true
}
if (valid) {
const label = c.name + ' -￥' + this.$options.filters.fen2yuan(discount)
if (discount > maxCouponDiscount) {
maxCouponDiscount = discount
bestCouponId = c._id
}
coupons.push({
_id: c._id,
code: c.code,
key: c._id,
value: label,
discount: discount,
fixedFreight: c.fixedFreight,
freight: c.freight
})
}
}
}
})
this.availableCoupons = coupons
this.couponId = bestCouponId
},
getDefaultAddress() {
Api.getDefaultAddress().then(res => {
this.addressInfo = res.data
if (this.shippingMethodsList.length > 0) {
this.updateAvailableShippingMethodsList()
}
})
},
changeAddressInfo(item) {
this.addressInfo = item
if (this.shippingMethodsList.length > 0) {
this.updateAvailableShippingMethodsList()
}
},
createOrder() {
if(!this.addressInfo){
this.$vux.alert.show({
title: '警告！',
content: '请选择收货地址！'
})
return
}

if(!this.fixedFreight && this.shippingMethodsList.length > 0 && !this.shippingMethodId ){
this.$store.commit('updateToast', {
text: '请选择配送方式',
show: true
});
return
}

let postParams = {
products: this.products,
address: this.addressInfo,
channel: localStorage.getItem('channel')
}
if(this.shippingMethodId){ // 配送方式
postParams.shippingMethod = this.shippingMethodId
}
if(this.couponId){ // 优惠券
postParams.coupon = this.couponId
}

Api.createOrder(postParams)
.then(res => {
if (this.$route.query.selectedCart) {
const productIds = _.map(this.products, 'product')
Api.batchDeleteProductCart({products: productIds})
}
this.$router.replace({
name: 'orderList',
params: {
pathName: 'all'
},
query: {
payingOrderId: res.data._id
}
})
})
.catch(e => {
if (e && e.response && e.response.data) {
if (e.response.data.message == 'The coupon has been used already!') {
this.$vux.alert.show({
title: '创建订单失败！',
content: '优惠券已被其他订单使用！'
})
return
} else {
var errorMessage = e.response.data.message
if (errorMessage == 'Product sold out!') {
errorMessage = '库存不足!'
}
this.$vux.alert.show({
title: '创建订单失败！',
content: errorMessage
})
}
} else {
this.$vux.alert.show({
title: '失败！',
content: '创建订单失败！'
})
}
})
},
updateAvailableShippingMethodsList() {
if (this.fixedFreight) {
return
}
this.shippingMethod = {}
this.shippingMethodId = null
this.shippingMethodName = ''
this.availableShippingMethodsList = []
if(this.addressInfo) {
_.forEach(this.shippingMethodsList, row => {
if (row.areaCodes.indexOf(this.addressInfo.areaCode[0]) > -1) {
this.availableShippingMethodsList.push({
key: row._id,
value: row.name
})
const freight = this.getShippingMethodFreight(row)
if (!this.shippingMethodId || freight < this.freight) {
this.shippingMethod = row
this.shippingMethodId = row._id
this.shippingMethodName = row.name
this.freight = freight
}
}
})
}
},
getShippingMethodFreight(shippingMethod) {
let freight = 0
if (!this.fixedFreight && this.countingQuantity > 0) {
if (shippingMethod.freeShipping == 'amount' && (this.productsPrice - this.discount) >= shippingMethod.freeShippingAmount) {
freight = 0
} else if (shippingMethod.freeShipping == 'quantity' && this.countingQuantity >= shippingMethod.freeShippingQuantity) {
freight = 0
} else if (shippingMethod.freightType == 'weight') {
freight = shippingMethod.firstPrice
if (this.countingWeight > shippingMethod.firstWeight) {
freight += Math.ceil((this.countingWeight - shippingMethod.firstWeight) / shippingMethod.additionalWeight) * shippingMethod.additionalPrice
}
} else if (shippingMethod.freightType == 'quantity') {
if (this.countingQuantity > 0) {
if (this.countingQuantity == this.totalQuantity) {
freight = shippingMethod.firstItemPrice
} else {
freight = shippingMethod.additionalItemPrice
}
if (this.countingQuantity > 1) {
freight += (this.countingQuantity - 1) * shippingMethod.additionalItemPrice
}
}
}
}
return freight
},
updateFreight() {
if (!this.fixedFreight && this.countingQuantity > 0) {
this.freight = 0
if (this.shippingMethodId) {
const shippingMethod = _.find(this.shippingMethodsList, {_id: this.shippingMethodId})
this.shippingMethod = shippingMethod
if (shippingMethod) {
this.freight = this.getShippingMethodFreight(shippingMethod)
}
}
}
},
updateCoupon(val) {
const selectedCoupon = this.availableCoupons.find(c => c.key == this.couponId)
this.discount = selectedCoupon.discount
this.fixedFreight = selectedCoupon.fixedFreight
this.freight = selectedCoupon.freight
if (!this.fixedFreight) {
this.updateAvailableShippingMethodsList()
}
}
},
mounted() {
this.getDefaultAddress()
},
beforeRouteEnter: (to, from, next) => {
next(vm => {
vm.fromFullPath = from.fullPath
})
}
}



// WEBPACK FOOTER //
// ./src/components/CreateOrder/CreateOrder.vue